import { Reveal } from "../lib/reveal";
import { useLang } from "../i18n/LanguageContext";

const chapters = [
  {
    n: "01",
    title: "Not a masking fragrance.",
    is: "A biological remediation platform.",
    body: "OED doesn't hide the smell of decay. Its indigenous microbial consortium metabolises the organic load driving the odour in the first place.",
  },
  {
    n: "02",
    title: "Not a sanitation additive.",
    is: "A landfill decomposition accelerator.",
    body: "By re-seeding biological activity, OED speeds the breakdown of legacy and fresh waste — shrinking recovery timelines and reclaiming land faster.",
  },
  {
    n: "03",
    title: "Not an odour-control chemical.",
    is: "A microbial ecosystem restoration solution.",
    body: "Rather than sterilising the site, OED rebuilds a living microbial ecosystem that keeps working long after application.",
  },
  {
    n: "04",
    title: "Not a one-off treatment.",
    is: "A public-health & ESG compliance tool.",
    body: "Measurable odour reduction, lower methane and cleaner sites help cities meet Swachh Bharat, NGT and ESG mandates with visible civic impact.",
  },
];

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative grain bg-forest text-bone py-24 md:py-32 overflow-hidden">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <Reveal className="flex items-center gap-3 mb-6">
                <span className="text-xs tracking-[0.22em] uppercase font-semibold text-bone/60">{t("Positioning", "स्थिति-निर्धारण")}</span>
              </Reveal>
              <Reveal>
                <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.02]">
                  {t("What OED", "OED क्या")} <span className="italic text-terracotta">{t("is", "है")}</span> {t("— and what it isn't.", "— और क्या नहीं है।")}
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-6 text-base leading-relaxed text-bone/70 max-w-sm">
                  {t(
                    "We are building a new category: biological landfill management. Four principles define the difference.",
                    "हम एक नई श्रेणी बना रहे हैं: जैविक लैंडफिल प्रबंधन। चार सिद्धांत इस अंतर को परिभाषित करते हैं।"
                  )}
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8 space-y-4">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05}>
                <div className="group border-t border-bone/15 pt-8 pb-8 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8">
                  <div className="md:col-span-2 font-serif text-5xl md:text-6xl text-bone/25 leading-none group-hover:text-terracotta transition-colors duration-500">
                    {c.n}
                  </div>
                  <div className="md:col-span-10">
                    <p className="text-sm tracking-[0.1em] uppercase text-bone/40 line-through decoration-terracotta/60">
                      {c.title}
                    </p>
                    <h3 className="font-serif text-3xl md:text-4xl mt-2 mb-4 leading-tight">{c.is}</h3>
                    <p className="text-base leading-relaxed text-bone/70 max-w-2xl">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
